<template>
  <div class="partner_thankyou">
	  <div class="container">
		  <div class="row">
			  <div class="col-md-12">
				  <div class="partner_thankyou_content">
						<img src="/frontend/wait_list/assets/image/partner_thankyou.png" class="img-fluid" alt="Thank You">
						<p>Thank you for contacting us. You have successfully placed a request on our waitlist.</p>
						<p>One of our experts will contact you shortly.</p>
				  </div>
			  </div>
		  </div>
	  </div>
  </div>
</template>

<script>
export default {
    name: "WaitListConfirmation"
}
</script>